module.exports = __webpack_public_path__ + "img/Success-Illustration@2x.fec6e2c7.png";